import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(true)

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span class="ns-facet-name">{facet.name}</span>
            </span>
            <div class="ns-sidebar-submenu ns-d-none">
                {max > 1500 &&
                    <div class="ns-d-flex ns-justify-content-between ns-font-4 ns-mt-4">
                        <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                            <label for={`ns-${facet.id}-min`} class="ns-form-label">
                                Min.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div class="ns-col-6 flex-shrink-1">
                            <label for={`ns-${facet.id}-max`} class="ns-form-label">
                                Max.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                }
                <RangeSlider id={facet.id} />
                <span class="ns-price-range">${min} - ${max}</span>
            </div>
        </li>
    )
}
